import {createStyles} from '@mantine/core';
import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import InlineBanner, {InlineBannerType} from 'ui-library/banners/InlineBanner';

const ANTIBODY_BETA_FEEDBACK_FORM = 'https://forms.gle/67i1WiTYjKMxsh7C8';

const useStyles = createStyles(() => ({
  bannerWrapper: {
    marginBottom: '16px',
  },
}));

/**
 * Render a banner for soliciting beta feedback for the antibody feature.
 */
export default function AntibodyFeedbackBanner(): JSX.Element {
  const {classes} = useStyles();
  if (BenchlingConfig.MOLBIO_HIDE_ANTIBODY_FEEDBACK_BANNER) {
    return <></>;
  }
  return (
    <div className={classes.bannerWrapper}>
      <InlineBanner
        bannerType={InlineBannerType.BETA}
        hideIcon={true}
        text={
          <>
            Proteins are a new beta feature.{' '}
            <a href={ANTIBODY_BETA_FEEDBACK_FORM} target="_blank" rel="noreferrer">
              Share feedback
            </a>
          </>
        }
      />
    </div>
  );
}
